// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-wrapper[data-v-33226065]{width:50%}@media(max-width: 968px){.form-wrapper[data-v-33226065]{width:100%}}.paypal-gap[data-v-33226065]{gap:1rem}.paypal-signature[data-v-33226065]{max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);
// Exports
module.exports = exports;
